// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import VueResource from 'vue-resource'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css'
// import Axios from "axios"
import store from './store/index'
import Components from './util/components'
import Path from './util/path'
import SlideVerify from 'vue-monoplasty-slide-verify';

Vue.use(ElementUI)
Vue.use(SlideVerify)
Vue.use(VueResource)
Vue.use(Components)
Vue.use(Path)
Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios
Vue.prototype.$store = store
// axios.defaults.withCredentials = true
axios.defaults.headers.common['Authorization'] = store.state.Authorization;
axios.defaults.headers.common['Content-Type'] = 'application/x-www-form-urlencoded';
// 页面打开时更新一下用户信息
if (store.state.Authorization) {
    store.commit('changeLogin', { Authorization: store.state.Authorization })
}

let clearAuthor = function () {
    localStorage.removeItem('user');
    localStorage.removeItem('Authorization');
    delete axios.defaults.headers.common['Authorization'];
    store.commit('clearAuthor')
};
Vue.prototype.clearAuthor = clearAuthor;

Vue.prototype.changeLogin = function (token) {
    axios.defaults.headers.common['Authorization'] = token;
    store.commit('changeLogin', { Authorization: token })
};

Vue.prototype.$getRegistrationItem = function () {
    let registrationItems = localStorage.getItem('registrationItems');
    return registrationItems ? JSON.parse(registrationItems) : {};
};
router.beforeEach((to, from, next) => {
    if(to.meta.requireAuth){
        if(localStorage.getItem('datas')){
          next()
          let title = JSON.parse(localStorage.getItem('platform')).platformName
          window.document.title = to.meta.title == '' ? title : to.meta.title
        }else{
          axios.get( Vue.prototype.$managePath + "/offline/api/getPlatform?domain="+ document.domain).then(res=>{
            var data = res.data.data.id
            localStorage.setItem('datas',data);
            store.commit('setPlatform', res.data.data)
            next()
            let title = JSON.parse(localStorage.getItem('platform')).platformName
            window.document.title = to.meta.title == '' ? title : to.meta.title
          })
        }
    }
})
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});

// 序列化参数
const paramsStr = params => {
    let str = "";
    if (typeof params === "object" && typeof params !== null) {
        Object.keys(params).forEach(key => {
            const element = params[key];
            if (element || element == 0) {
                if (str) {
                    str += `&${key}=${element}`;
                } else {
                    str += `?${key}=${element}`;
                }
            }
        });
    }
    return str;
};
// 存储所有的请求
let request = [];
// 删除请求
const removeReuest = (url, data) => {
    request.forEach((item, index) => {
        if (item === `${url}${data}`) {
            request.splice(index, 1);
        }
    });
};

// 添加请求拦截器
axios.interceptors.request.use(
    config => {
        const flag = request.find(
            item => item === `${config.url}${paramsStr(config.data)}`
        );
        if (flag) {
            return Promise.reject("cancel");
        }
        // 否则把数据推入request，储存当前请求 这里使用url和序列化参数组成唯一标识（可以改成自己的需要的）
        // request.push(`${config.url}${paramsStr(config.data)}`);
        return config;
    },
    error => {
        return Promise.reject(error);
    });
axios.interceptors.response.use(
    response => {
        if (response.data.status === '401') {
            clearAuthor();
            router.push({ name: 'StudentLogin' })
        }
        return response;
    }, error => {
        if (error.message !== "cancel") {
            request.pop();
        }
        return Promise.reject(error);
    }
)



// WEBPACK FOOTER //
// ./src/main.js